import {
  createFileRoute,
  useNavigate,
  useSearch,
} from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/product/add-product/sale-settings/product-settings/'
)({
  validateSearch: searchSchema,
  component: ProductSettingsPage,
});

function ProductSettingsPage() {
  const navigate = useNavigate();
  const { id: productId } = useSearch({
    from: '/dashboard/product/add-product/sale-settings/product-settings/',
  });

  useEffect(() => {
    navigate({
      to: '/dashboard/product/add-product',
      search: { id: productId, step: 'variants' },
      replace: true,
    });
  }, [productId, navigate]);

  return null;
}
